import React, { useState, useEffect, createContext, useContext } from "react";
import { CarrierContext } from "../contexts/CarrierContext";
import { getAPIData } from "../services/guestService";
import { v4 as uuidv4 } from "uuid";
import { useLocation } from "react-router-dom";
import { LogContext } from "./LogContext";

export const LanguageContext = createContext();
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("eng");
  const [cmsAllPages, setCMS] = useState([]);
  const carrierContxt = useContext(CarrierContext);
  const [langErr, setLangErr] = useState("");
  // const [cmsApiEndPoint, setCmsApiEndPoint] = useState("");
  const [cmsApiRespAllContent, setCmsApiRespAllContent] = useState([]);
  //const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { Log } = useContext(LogContext);

  const handleLanguage = (lang) => {
    sessionStorage.setItem("langSel", lang);
    //setLanguage(sessionStorage.getItem("langSel"));
    setLanguage(lang);
  };

  /*const handleLanguage = (e) => {
    setLanguage(e.target.value);
  };*/
  useEffect(() => {
    let pathName = location.pathname;

    let cmsApiEndpoint = "";
    let path = pathName.startsWith("/") ? pathName.slice(1) : pathName;
    const urlCarrier = carrierContxt.hasOwnProperty("carrier")
      ? carrierContxt.carrier
      : null;
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    if (urlCarrier) {
      // If carrier name is in url
      if (path) {
        if (path === urlCarrier || path === urlCarrier + "/") {
          //if comes as  cigna or cigna/
          if (sessionStorage.getItem("userData_" + process.env[carr_code])) {
            cmsApiEndpoint =
              process.env.REACT_APP_CMS_API_ENDPOINT + "makepayment";
            /*setCmsApiEndPoint(
              process.env.REACT_APP_CMS_API_ENDPOINT + "makepayment"
            );*/
          } else {
            cmsApiEndpoint = process.env.REACT_APP_CMS_API_ENDPOINT + "login";
            //setCmsApiEndPoint(process.env.REACT_APP_CMS_API_ENDPOINT + "login");
          }
        } else {
          const apiParam = pathName.includes("/" + urlCarrier)
            ? pathName.replace("/" + urlCarrier + "/", "")
            : pathName;
          cmsApiEndpoint = process.env.REACT_APP_CMS_API_ENDPOINT + apiParam;
          //setCmsApiEndPoint(process.env.REACT_APP_CMS_API_ENDPOINT + apiParam);
        }
      } else {
        cmsApiEndpoint = process.env.REACT_APP_CMS_API_ENDPOINT + "login";
        // setCmsApiEndPoint(process.env.REACT_APP_CMS_API_ENDPOINT + "login");
      }

      /* Call to CMS API */
      //setLoading(true); //Show loader
      if (cmsApiEndpoint) {
        //API endpoint-login if user logged in or prelogin if not logged in
        const guid = uuidv4();
        const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
        const carr_code_val = process.env[carr_code];
        const lang_client_id = "REACT_APP_CMS_API_CLIENT_ID_" + carr_code_val;
        const lang_client_secret =
          "REACT_APP_CMS_API_CLIENT_SECRET_" + carr_code_val;
        const headers = {
          "X-Hps-Trace-Id": guid,
          "X-Hps-Ts": Date.now(),
          "X-Hps-Carrier-Code": process.env[carr_code],
          "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
          "X-Hps-SiteCd": process.env[carr_code] + "GPT",
          "Content-Type": "application/json",
          "X-Hps-Client-Id": process.env[lang_client_id],
          "X-Hps-Secret-Id": process.env[lang_client_secret],
          "X-Hps-Db-Region": process.env.REACT_APP_REGION,
        };
        getAPIData(
          // API call
          process.env.REACT_APP_API_HTTP_URL + process.env.REACT_APP_API_PATH,
          cmsApiEndpoint,
          headers
        )
          .then((result) => {
            if (result.status && result.data && result.status === 200) {
              //If no AXIOS err
              const response = result.data;
              //console.log(response);
              if (!response.error) {
                //If no API resp error
                if (response.status_code && response.status_code === "HPS200") {
                  //If API resp success
                  const pageContent = response.page_content
                    ? response.page_content
                    : null;
                  setCmsApiRespAllContent(pageContent);
                  /* const selLangData =
                    pageContent && pageContent[language]
                      ? pageContent[language]
                      : null;
                  if (!selLangData) {
                    //Incase CMS content is not set
                    setLangErr("Technical error: No language set !");
                  } else {
                    setLangErr("");
                  }
                  setCMS(selLangData);*/
                } else {
                  //If API resp not success
                  Log(
                    "CMS API",
                    "API",
                    "",
                    "API failure",
                    "ERROR",
                    headers,
                    result,
                    process.env.REACT_APP_API_HTTP_URL +
                      process.env.REACT_APP_API_PATH +
                      cmsApiEndpoint,
                    "F"
                  );
                  const errCode = response.status_code
                    ? response.status_code
                    : "";
                  // setLangErr(errCode + " Technical error: No language set !");
                }
              } else {
                //If API resp error
                Log(
                  "CMS API",
                  "API",
                  "",
                  "API failure",
                  "ERROR",
                  headers,
                  result,
                  process.env.REACT_APP_API_HTTP_URL +
                    process.env.REACT_APP_API_PATH +
                    cmsApiEndpoint,
                  "F"
                );
                // setLangErr("Technical error: No language set !");
              }
            } else {
              // API err
              Log(
                "CMS API",
                "API",
                "",
                "API failure",
                "ERROR",
                headers,
                result,
                process.env.REACT_APP_API_HTTP_URL +
                  process.env.REACT_APP_API_PATH +
                  cmsApiEndpoint,
                "F"
              );
              //setLangErr(result.status + " Technical error: No language set !");
            }
          })
          .catch((err) => {
            Log(
              "CMS API",
              "API",
              "",
              "Got exception: API failure",
              "ERROR",
              headers,
              err,
              process.env.REACT_APP_API_HTTP_URL +
                process.env.REACT_APP_API_PATH +
                cmsApiEndpoint,
              "F"
            );
            setLangErr("Technical error: No language set !");
          })
          .finally(() => {
            // Code that runs regardless of success or failure
            //  setLoading(false); //Hide loader
          });
      }
      //   console.log(langErr);
    }
  }, [carrierContxt, location, Log]);

  useEffect(() => {
    const langSet =
      sessionStorage.getItem("langSel") !== null
        ? sessionStorage.getItem("langSel")
        : language;

    const selLangData =
      cmsApiRespAllContent && cmsApiRespAllContent[langSet]
        ? cmsApiRespAllContent[langSet]
        : null;
    //console.log(selLangData);
    if (selLangData) {
      //If CMS content is set
      setLangErr("");
      setCMS(selLangData);
    }
  }, [cmsApiRespAllContent, language]);

  return (
    <LanguageContext.Provider value={{ cmsAllPages, handleLanguage, langErr }}>
      {children}
    </LanguageContext.Provider>
  );
};
